import React, {Component} from 'react';
import "./decoration.css";

class OrderPageProgressBar extends Component {

  render() {
    const chosenId = "curItem";
    let props = this.props

    return(
      <div className="OrderPageProgressBar">
        <div className="OrderPageProgressItem" id={`${props.index>=1?chosenId:''}`}>
          <div className="OrderPageProgressCircle"> 1 </div>
          <div className="OrderPageProgressCaption"> CART LIST </div>
        </div>
        <div className="OrderPageProgressArrow"> > </div>
        <div className="OrderPageProgressItem" id={`${props.index>=2?chosenId:''}`}>
          <div className="OrderPageProgressCircle"> 2 </div>
          <div className="OrderPageProgressCaption"> INFO </div>
        </div>
        <div className="OrderPageProgressArrow"> > </div>
        <div className="OrderPageProgressItem" id={`${props.index>=3?chosenId:''}`}>
          <div className="OrderPageProgressCircle"> 3 </div>
          <div className="OrderPageProgressCaption"> SUBMIT </div>
        </div>
        <div className="OrderPageProgressArrow"> > </div>
        <div className="OrderPageProgressItem" id={`${props.index>=4?chosenId:''}`}>
          <div className="OrderPageProgressCircle"> 4 </div>
          <div className="OrderPageProgressCaption"> COMPLETE </div>
        </div>
      </div>
    );
  }
}

export default OrderPageProgressBar;



// WEBPACK FOOTER //
// ./src/components/decoration/orderPageProgressBar.js